import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-weight-bold mb-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InfoIconWithTooltip = _resolveComponent("InfoIconWithTooltip");
    const _component_BFormCheckbox = _resolveComponent("BFormCheckbox");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.tr('viiu.componentMuting.PREVENTION_BEHAVIOR')) + " ", 1),
            _createVNode(_component_InfoIconWithTooltip, {
                class: "ml-2",
                title: _ctx.tr('viiu.componentMuting.PREVENTION_BEHAVIOR_TOOLTIP')
            }, null, 8, ["title"])
        ]),
        _createVNode(_component_BFormCheckbox, {
            modelValue: _ctx.preventionBehavior,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.preventionBehavior) = $event))
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.tr('viiu.componentMuting.PREVENTION_BEHAVIOR_CHECKBOX')), 1)
            ], undefined, true),
            _: 1
        }, 8, ["modelValue"])
    ]));
}
